import { render, staticRenderFns } from "./MyCheckCrifStatus.vue?vue&type=template&id=c02acf56&"
import script from "./MyCheckCrifStatus.vue?vue&type=script&lang=js&"
export * from "./MyCheckCrifStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports